// Path: ./src/app/components/CreateDealTopNav/styled.ts
import styled from "styled-components";

export const TopNavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  height: 60px;
  overflow: hidden;
  width: 100vw;
  border-bottom: 3px solid #e6e6e6;
  padding-left: 10px;

  @media (max-width: 590px) {
    height: 50px;
  }
`;

interface TopButtonNavigateProps {
  index?: string | number | undefined;
  value?: string | number | undefined;
}
export const TopButtonNavigate = styled.div<TopButtonNavigateProps>`
  font-weight: 500;
  padding: 16px;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-right: 30px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 10px;
  font-size: ${(props) => {
    return props.index === props.value ? "20px" : "18px";
  }};
  background-color: ${(props) => {
    return props.index === props.value ? "#ff813a" : "white";
  }};
  color: ${(props) => {
    return props.index === props.value ? "white" : "black";
  }};
  &:hover {
    font-size: 20px;
    background-color: #ff813a;
    color: white;
  }
  @media (max-width: 590px) {
    font-size: 14px;
    margin-right: 10px;
    &:hover {
      font-size: 16px;
    }
  }
`;
